import type { ILanguageResources, ITranslationModule } from '../../../../../interfaces';
import { interpolate } from '../../../../../global';

// eslint-disable-next-line @typescript-eslint/no-extraneous-class
class Id {
  private constructor() {}
  public static readonly prefix = 'UI.scripts.dealer-franchisee.quotes.data.v6.OutOfDateQuoteItemHandlerSafeMode.';
  public static readonly couldNotBeSaved = `${Id.prefix}couldNotBeSaved`;
  public static readonly itemCouldNotBeSaved = `${Id.prefix}itemCouldNotBeSaved`;
  public static readonly errorRevalidating = `${Id.prefix}errorRevalidating`;
  public static readonly itemReason = `${Id.prefix}itemReason`;
  public static readonly newValidationsDontMatch = `${Id.prefix}newValidationsDontMatch`;
  public static readonly frameDesignChanged = `${Id.prefix}frameDesignChanged`;
  public static readonly version = `${Id.prefix}version`;
}

// eslint-disable-next-line @typescript-eslint/no-extraneous-class
export class LangOutOfDateQuoteItemHandlerSafeMode {
  private constructor() {}
  public static couldNotBeSaved(): string {
    return interpolate(Id.couldNotBeSaved);
  }
  public static itemCouldNotBeSaved(params: { position: number }): string {
    return interpolate(Id.itemCouldNotBeSaved, params);
  }
  public static errorRevalidating(): string {
    return interpolate(Id.errorRevalidating);
  }
  public static itemReason(params: { position: number; reason: string }): string {
    return interpolate(Id.itemReason, params);
  }
  public static newValidationsDontMatch(): string {
    return interpolate(Id.newValidationsDontMatch);
  }
  public static frameDesignChanged(): string {
    return interpolate(Id.frameDesignChanged);
  }
  public static version(): string {
    return interpolate(Id.version);
  }
}

export class OutOfDateQuoteItemHandlerSafeModeModule implements ITranslationModule {
  registerItems(register: ILanguageResources) {
    register.add(Id.couldNotBeSaved, 'could not be saved', 'Error message when an item could not be saved');
    register.add(
      Id.itemCouldNotBeSaved,
      'Item: {{position}} could not be saved',
      'Error message for a specific item that could not be saved'
    );
    register.add(Id.errorRevalidating, 'Error re-validating', 'Title for error re-validating');
    register.add(Id.itemReason, '\n Item {{position}}: {{reason}} ', 'Error reason for a specific item');
    register.add(
      Id.newValidationsDontMatch,
      'new Validations dont match',
      'Error message for new validations not matching'
    );
    register.add(
      Id.frameDesignChanged,
      "{{glossary 'frame'}} Design Changed",
      'Error message for frame design changed'
    );
    register.add(Id.version, 'Version', 'Label for version');
  }
}
